export default __webpack_public_path__ + "static/thank-you-bg-08b342640d6e85484f1a2d3539492697.jpg";